// Central API configuration - dynamically supports .com, .in, .de, and staging
const configuredApiBase = import.meta.env.VITE_API_BASE;

const API_BASE = configuredApiBase
  ? configuredApiBase
  : (window.location.origin.includes('localhost')
      ? 'https://lime-parrot-358941.hostingersite.com/backend'
      : window.location.origin + '/backend');

export const API = {
  auth: {
    login: `${API_BASE}/api/auth/login.php`,
    register: `${API_BASE}/api/auth/register.php`,
  },
  products: {
    list: `${API_BASE}/api/products/list.php`,
    get: (id) => `${API_BASE}/api/products/get.php?id=${id}`,
    categories: `${API_BASE}/api/products/categories.php`,
  },
  reviews: {
    list: (productId) => `${API_BASE}/api/products/reviews.php?product_id=${productId}`,
    submit: `${API_BASE}/api/products/reviews.php`,
    uploadImage: `${API_BASE}/upload_review_image.php`,
  },
  nav: {
    menu: `${API_BASE}/api/nav/menu.php`,
  },
  settings: {
    hero: `${API_BASE}/api/settings/hero.php`,
  },
  contact: {
    submit: `${API_BASE}/api/contact/submit.php`,
  },
  orders: {
    create: `${API_BASE}/api/orders/create.php`,
    verify: `${API_BASE}/api/orders/verify_payment.php`,
    userOrders: `${API_BASE}/api/orders/user_orders.php`,
    get: (orderPublicId, email = '', phone = '') => `${API_BASE}/api/orders/get.php?order_public_id=${encodeURIComponent(orderPublicId)}${email ? `&email=${encodeURIComponent(email)}` : ''}${phone ? `&phone=${encodeURIComponent(phone)}` : ''}`,
  },
  admin: {
    categories: `${API_BASE}/api/admin/categories.php`,
    products: `${API_BASE}/api/admin/products.php`,
    orders: `${API_BASE}/api/admin/orders.php`,
    users: `${API_BASE}/api/admin/users.php`,
    navSections: `${API_BASE}/api/admin/nav_sections.php`,
    settings: `${API_BASE}/api/admin/settings.php`,
  },
};

export default API;
